import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

// Utility for combining Tailwind classes
export const cn = (...inputs: ClassValue[]) => {
  return twMerge(clsx(inputs))
} 